import { CurrentUnit } from '../enums';

export const CURRENT_UNITS = new Map<CurrentUnit, string>([
    [CurrentUnit.A, '[A]'],
    [CurrentUnit.IIn, '[I/In]']
]);
